<template>
    <section class="odocs-spaced">
        <p>
            <o-tooltip label="Default">
                <o-button label="Default" />
            </o-tooltip>

            <o-tooltip label="Primary" variant="primary">
                <o-button label="Primary" variant="primary" />
            </o-tooltip>

            <o-tooltip label="Secondary" variant="secondary">
                <o-button label="Secondary" variant="secondary" />
            </o-tooltip>

            <o-tooltip label="Success" variant="success">
                <o-button label="Success" variant="success" />
            </o-tooltip>

            <o-tooltip label="Danger" variant="danger">
                <o-button label="Danger" variant="danger" />
            </o-tooltip>

            <o-tooltip label="Warning" variant="warning">
                <o-button label="Warning" variant="warning" />
            </o-tooltip>

            <o-tooltip label="Info" variant="info">
                <o-button label="Info" variant="info" />
            </o-tooltip>
        </p>
    </section>
</template>
